exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h2_title[data-v-165d14f1] {\n  font-weight: normal;\n}\n", ""]);

// exports
